import React, { useContext } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { AppContext } from "../../context/AppContextProvider";

const HaqtBreadcrumb = () => {
  const { breadcrumbs } = useContext(AppContext);
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{ 
        height: 40, 
        mb: { xs: 2 } 
      }}
    >
      {breadcrumbs.map((item, index) => {
        return (
          <Typography color="text.primary" variant="subtitle2" key={index}>
            {item}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default HaqtBreadcrumb;
